// Theme palette paths used to colour user/group avatars by a hash of their id.
// Co-located with the theme so the avatar colour set lives in one place and can be
// tuned without touching the hashing logic. Each background is paired with the
// foreground the design system defines for it — lime and mint carry dark initials,
// the rest white — so the initials stay legible on every entry.
export const AVATAR_COLOURS = [
  { backgroundColor: 'bg.brand.default', color: 'text.brand.onBrand' },
  { backgroundColor: 'bg.utility.plum.default', color: 'text.utility.plum.on-plum' },
  { backgroundColor: 'bg.success.default', color: 'text.success.onSuccess' },
  { backgroundColor: 'bg.utility.lime.default', color: 'text.utility.lime.on-lime' },
  { backgroundColor: 'bg.info.default', color: 'text.info.onInfo' },
  { backgroundColor: 'bg.utility.mint.default', color: 'text.utility.mint.on-mint' },
  { backgroundColor: 'bg.utility.orange.default', color: 'text.utility.orange.on-orange' },
  { backgroundColor: 'bg.utility.pink.default', color: 'text.utility.pink.on-pink' },
  { backgroundColor: 'bg.utility.bronze.default', color: 'text.utility.bronze.on-bronze' },
  { backgroundColor: 'bg.utility.gold.default', color: 'text.utility.gold.on-gold' },
] as const

export type AvatarColour = (typeof AVATAR_COLOURS)[number]
